<template>
  <div class="container bg-white pt-5">
    <div class="row">
      <div class="col-md-12">
        <sectoral-pe-ratio></sectoral-pe-ratio>
      </div>
    </div>
  </div>
</template>

<script>
import SectoralPeRatio from './SectoralPeRatio.vue'
export default {
  components: {
    SectoralPeRatio
  },
};
</script>

<style></style>
